'use client';

import { ChatIcon } from '@jouzen/ecom-components/icons/ChatIcon';
import { Button } from '@jouzen/ecom-components/v3/Button';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';
import { useState } from 'react';

import Motion from '../Motion';

export interface ChatbotTriggerButtonProps {
  readonly className?: string;
  readonly onClick?: () => void;
}

const ChatbotTriggerButton = ({
  className,
  onClick,
}: ChatbotTriggerButtonProps) => {
  const t = useTranslations();
  const [isHovered, setIsHovered] = useState<boolean>(false);

  return (
    <Motion
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
    >
      <Button
        variant="secondary"
        className={cx(
          'flex items-center justify-center p-[10px] md:p-3',
          className,
        )}
        data-cy="chatbot-trigger-button"
        onClick={onClick}
      >
        <span className="flex flex-nowrap items-center justify-center">
          <Motion
            el="span"
            animate={isHovered ? 'hover' : 'default'}
            initial="default"
            transition={{ duration: 0.3, ease: 'easeInOut' }}
            variants={{
              default: {
                width: 0,
              },
              hover: {
                width: 'auto',
              },
            }}
          >
            <Typography className="mr-2 overflow-x-hidden text-xs text-nowrap">
              {t('chatbot_button_text')}
            </Typography>
          </Motion>
          <ChatIcon className="size-5 md:size-6" />
        </span>
        <span className="sr-only">{t('chatbot_open')}</span>
      </Button>
    </Motion>
  );
};

export default ChatbotTriggerButton;
